import { render, staticRenderFns } from "./I18nResourceEdit.vue?vue&type=template&id=17560d02&scoped=true&"
import script from "./I18nResourceEdit.vue?vue&type=script&lang=js&"
export * from "./I18nResourceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17560d02",
  null
  
)

export default component.exports